// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { DownloadType, ReportFrequency, ReportType, TransferProtocol, NewB2BReportForm } from "../schema";

export function serialize_NewB2BReportForm(obj: NewB2BReportForm): string {
  const serialized = ((value: {
    active: boolean;
    activeUsersOnly: boolean;
    b2bCustomReport: boolean;
    ccRecipients: string;
    corporateId: number;
    customerId: number;
    dayOfWeek: number;
    downloadType: DownloadType;
    emailAdministrator: string | null;
    frequency: ReportFrequency;
    fromDate: { year: number; month: number; day: number } | null;
    ftpFolder: string;
    ftpHost: string;
    ftpPassphrase: string;
    ftpPassword: string;
    ftpPort: number;
    ftpRemoteFileName: string;
    ftpUserName: string;
    prefixFileName: boolean;
    privateKey: string | null;
    privateKeyContent: string;
    privateKeyEnabled: boolean;
    reportId: number;
    reportName: string;
    reportType: ReportType;
    specialReport: boolean;
    targetExcel: boolean;
    toDate: { year: number; month: number; day: number } | null;
    transferProtocol: TransferProtocol;
    zipFile: boolean;
  }): unknown => {
    return {
      active: ((value: boolean): unknown => {
        return value;
      })(value["active"]),
      activeUsersOnly: ((value: boolean): unknown => {
        return value;
      })(value["activeUsersOnly"]),
      b2bCustomReport: ((value: boolean): unknown => {
        return value;
      })(value["b2bCustomReport"]),
      ccRecipients: ((value: string): unknown => {
        return value;
      })(value["ccRecipients"]),
      corporateId: ((value: number): unknown => {
        return value;
      })(value["corporateId"]),
      customerId: ((value: number): unknown => {
        return value;
      })(value["customerId"]),
      dayOfWeek: ((value: number): unknown => {
        return value;
      })(value["dayOfWeek"]),
      downloadType: ((value: "PUSH" | "PULL" | "BOTH"): unknown => {
        return value;
      })(value["downloadType"]),
      emailAdministrator: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["emailAdministrator"]),
      frequency: ((value: "ONE_TIME" | "DAILY" | "WEEKLY" | "MONTHLY"): unknown => {
        return value;
      })(value["frequency"]),
      fromDate: ((value: { year: number; month: number; day: number } | null): unknown => {
        if (value === null) {
          return null;
        }
        return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
      })(value["fromDate"]),
      ftpFolder: ((value: string): unknown => {
        return value;
      })(value["ftpFolder"]),
      ftpHost: ((value: string): unknown => {
        return value;
      })(value["ftpHost"]),
      ftpPassphrase: ((value: string): unknown => {
        return value;
      })(value["ftpPassphrase"]),
      ftpPassword: ((value: string): unknown => {
        return value;
      })(value["ftpPassword"]),
      ftpPort: ((value: number): unknown => {
        return value;
      })(value["ftpPort"]),
      ftpRemoteFileName: ((value: string): unknown => {
        return value;
      })(value["ftpRemoteFileName"]),
      ftpUserName: ((value: string): unknown => {
        return value;
      })(value["ftpUserName"]),
      prefixFileName: ((value: boolean): unknown => {
        return value;
      })(value["prefixFileName"]),
      privateKey: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["privateKey"]),
      privateKeyContent: ((value: string): unknown => {
        return value;
      })(value["privateKeyContent"]),
      privateKeyEnabled: ((value: boolean): unknown => {
        return value;
      })(value["privateKeyEnabled"]),
      reportId: ((value: number): unknown => {
        return value;
      })(value["reportId"]),
      reportName: ((value: string): unknown => {
        return value;
      })(value["reportName"]),
      reportType: ((value: "USERS" | "ACTIVITY" | "EXTENDED_USERS_EXPORT" | "ACTIONABLES_ACTIVITY"): unknown => {
        return value;
      })(value["reportType"]),
      specialReport: ((value: boolean): unknown => {
        return value;
      })(value["specialReport"]),
      targetExcel: ((value: boolean): unknown => {
        return value;
      })(value["targetExcel"]),
      toDate: ((value: { year: number; month: number; day: number } | null): unknown => {
        if (value === null) {
          return null;
        }
        return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
      })(value["toDate"]),
      transferProtocol: ((value: "FTP" | "SFTP" | "FTPS"): unknown => {
        return value;
      })(value["transferProtocol"]),
      zipFile: ((value: boolean): unknown => {
        return value;
      })(value["zipFile"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_NewB2BReportForm(str: string): ParserResult<NewB2BReportForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    active: boolean;
    activeUsersOnly: boolean;
    b2bCustomReport: boolean;
    ccRecipients: string;
    corporateId: number;
    customerId: number;
    dayOfWeek: number;
    downloadType: DownloadType;
    emailAdministrator: string | null;
    frequency: ReportFrequency;
    fromDate: { year: number; month: number; day: number } | null;
    ftpFolder: string;
    ftpHost: string;
    ftpPassphrase: string;
    ftpPassword: string;
    ftpPort: number;
    ftpRemoteFileName: string;
    ftpUserName: string;
    prefixFileName: boolean;
    privateKey: string | null;
    privateKeyContent: string;
    privateKeyEnabled: boolean;
    reportId: number;
    reportName: string;
    reportType: ReportType;
    specialReport: boolean;
    targetExcel: boolean;
    toDate: { year: number; month: number; day: number } | null;
    transferProtocol: TransferProtocol;
    zipFile: boolean;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "active")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/active]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'active'.` };
    }
    const parsed_active = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/active]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["active"]);
    })();
    if (!parsed_active.success) {
      return { success: false, reason: parsed_active.reason };
    }
    if (!hasProp(value, "activeUsersOnly")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/activeUsersOnly]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activeUsersOnly'.` };
    }
    const parsed_activeUsersOnly = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/activeUsersOnly]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["activeUsersOnly"]);
    })();
    if (!parsed_activeUsersOnly.success) {
      return { success: false, reason: parsed_activeUsersOnly.reason };
    }
    if (!hasProp(value, "b2bCustomReport")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/b2bCustomReport]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'b2bCustomReport'.` };
    }
    const parsed_b2bCustomReport = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/b2bCustomReport]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["b2bCustomReport"]);
    })();
    if (!parsed_b2bCustomReport.success) {
      return { success: false, reason: parsed_b2bCustomReport.reason };
    }
    if (!hasProp(value, "ccRecipients")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ccRecipients]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ccRecipients'.` };
    }
    const parsed_ccRecipients = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ccRecipients]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["ccRecipients"]);
    })();
    if (!parsed_ccRecipients.success) {
      return { success: false, reason: parsed_ccRecipients.reason };
    }
    if (!hasProp(value, "corporateId")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/corporateId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'corporateId'.` };
    }
    const parsed_corporateId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/NewB2BReportForm/corporateId]: '${value}' expected to be of type number.` };
      })(value["corporateId"]);
    })();
    if (!parsed_corporateId.success) {
      return { success: false, reason: parsed_corporateId.reason };
    }
    if (!hasProp(value, "customerId")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
    }
    const parsed_customerId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/NewB2BReportForm/customerId]: '${value}' expected to be of type number.` };
      })(value["customerId"]);
    })();
    if (!parsed_customerId.success) {
      return { success: false, reason: parsed_customerId.reason };
    }
    if (!hasProp(value, "dayOfWeek")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/dayOfWeek]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'dayOfWeek'.` };
    }
    const parsed_dayOfWeek = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/NewB2BReportForm/dayOfWeek]: '${value}' expected to be of type number.` };
      })(value["dayOfWeek"]);
    })();
    if (!parsed_dayOfWeek.success) {
      return { success: false, reason: parsed_dayOfWeek.reason };
    }
    if (!hasProp(value, "downloadType")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/downloadType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'downloadType'.` };
    }
    const parsed_downloadType = ((): ParserResult<DownloadType> => {
      return ((value: unknown): ParserResult<DownloadType> => {
        return ((value: unknown): ParserResult<"PUSH" | "PULL" | "BOTH"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/DownloadType]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "PUSH":
              return { success: true, value: "PUSH" };
            case "PULL":
              return { success: true, value: "PULL" };
            case "BOTH":
              return { success: true, value: "BOTH" };
            default:
              return { success: false, reason: `[#/components/schemas/DownloadType]: '${value}' expected to be enum, one of 'PUSH, PULL, BOTH'.` };
          }
        })(value);
      })(value["downloadType"]);
    })();
    if (!parsed_downloadType.success) {
      return { success: false, reason: parsed_downloadType.reason };
    }
    if (!hasProp(value, "emailAdministrator")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/emailAdministrator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'emailAdministrator'.` };
    }
    const parsed_emailAdministrator = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/emailAdministrator]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["emailAdministrator"]);
    })();
    if (!parsed_emailAdministrator.success) {
      return { success: false, reason: parsed_emailAdministrator.reason };
    }
    if (!hasProp(value, "frequency")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/frequency]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'frequency'.` };
    }
    const parsed_frequency = ((): ParserResult<ReportFrequency> => {
      return ((value: unknown): ParserResult<ReportFrequency> => {
        return ((value: unknown): ParserResult<"ONE_TIME" | "DAILY" | "WEEKLY" | "MONTHLY"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/ReportFrequency]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "ONE_TIME":
              return { success: true, value: "ONE_TIME" };
            case "DAILY":
              return { success: true, value: "DAILY" };
            case "WEEKLY":
              return { success: true, value: "WEEKLY" };
            case "MONTHLY":
              return { success: true, value: "MONTHLY" };
            default:
              return { success: false, reason: `[#/components/schemas/ReportFrequency]: '${value}' expected to be enum, one of 'ONE_TIME, DAILY, WEEKLY, MONTHLY'.` };
          }
        })(value);
      })(value["frequency"]);
    })();
    if (!parsed_frequency.success) {
      return { success: false, reason: parsed_frequency.reason };
    }
    if (!hasProp(value, "fromDate")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/fromDate]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fromDate'.` };
    }
    const parsed_fromDate = ((): ParserResult<{ year: number; month: number; day: number } | null> => {
      return ((value: unknown): ParserResult<{ year: number; month: number; day: number } | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/fromDate]: '${value}' expected to be of type string.` };
        }
        const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/fromDate]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
        }
        return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
      })(value["fromDate"]);
    })();
    if (!parsed_fromDate.success) {
      return { success: false, reason: parsed_fromDate.reason };
    }
    if (!hasProp(value, "ftpFolder")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpFolder]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ftpFolder'.` };
    }
    const parsed_ftpFolder = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpFolder]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["ftpFolder"]);
    })();
    if (!parsed_ftpFolder.success) {
      return { success: false, reason: parsed_ftpFolder.reason };
    }
    if (!hasProp(value, "ftpHost")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpHost]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ftpHost'.` };
    }
    const parsed_ftpHost = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpHost]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["ftpHost"]);
    })();
    if (!parsed_ftpHost.success) {
      return { success: false, reason: parsed_ftpHost.reason };
    }
    if (!hasProp(value, "ftpPassphrase")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpPassphrase]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ftpPassphrase'.` };
    }
    const parsed_ftpPassphrase = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpPassphrase]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["ftpPassphrase"]);
    })();
    if (!parsed_ftpPassphrase.success) {
      return { success: false, reason: parsed_ftpPassphrase.reason };
    }
    if (!hasProp(value, "ftpPassword")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpPassword]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ftpPassword'.` };
    }
    const parsed_ftpPassword = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpPassword]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["ftpPassword"]);
    })();
    if (!parsed_ftpPassword.success) {
      return { success: false, reason: parsed_ftpPassword.reason };
    }
    if (!hasProp(value, "ftpPort")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpPort]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ftpPort'.` };
    }
    const parsed_ftpPort = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpPort]: '${value}' expected to be of type number.` };
      })(value["ftpPort"]);
    })();
    if (!parsed_ftpPort.success) {
      return { success: false, reason: parsed_ftpPort.reason };
    }
    if (!hasProp(value, "ftpRemoteFileName")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpRemoteFileName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ftpRemoteFileName'.` };
    }
    const parsed_ftpRemoteFileName = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpRemoteFileName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["ftpRemoteFileName"]);
    })();
    if (!parsed_ftpRemoteFileName.success) {
      return { success: false, reason: parsed_ftpRemoteFileName.reason };
    }
    if (!hasProp(value, "ftpUserName")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpUserName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ftpUserName'.` };
    }
    const parsed_ftpUserName = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/ftpUserName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["ftpUserName"]);
    })();
    if (!parsed_ftpUserName.success) {
      return { success: false, reason: parsed_ftpUserName.reason };
    }
    if (!hasProp(value, "prefixFileName")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/prefixFileName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'prefixFileName'.` };
    }
    const parsed_prefixFileName = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/prefixFileName]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["prefixFileName"]);
    })();
    if (!parsed_prefixFileName.success) {
      return { success: false, reason: parsed_prefixFileName.reason };
    }
    if (!hasProp(value, "privateKey")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/privateKey]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'privateKey'.` };
    }
    const parsed_privateKey = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/privateKey]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["privateKey"]);
    })();
    if (!parsed_privateKey.success) {
      return { success: false, reason: parsed_privateKey.reason };
    }
    if (!hasProp(value, "privateKeyContent")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/privateKeyContent]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'privateKeyContent'.` };
    }
    const parsed_privateKeyContent = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/privateKeyContent]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["privateKeyContent"]);
    })();
    if (!parsed_privateKeyContent.success) {
      return { success: false, reason: parsed_privateKeyContent.reason };
    }
    if (!hasProp(value, "privateKeyEnabled")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/privateKeyEnabled]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'privateKeyEnabled'.` };
    }
    const parsed_privateKeyEnabled = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/privateKeyEnabled]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["privateKeyEnabled"]);
    })();
    if (!parsed_privateKeyEnabled.success) {
      return { success: false, reason: parsed_privateKeyEnabled.reason };
    }
    if (!hasProp(value, "reportId")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/reportId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reportId'.` };
    }
    const parsed_reportId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/NewB2BReportForm/reportId]: '${value}' expected to be of type number.` };
      })(value["reportId"]);
    })();
    if (!parsed_reportId.success) {
      return { success: false, reason: parsed_reportId.reason };
    }
    if (!hasProp(value, "reportName")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/reportName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reportName'.` };
    }
    const parsed_reportName = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/reportName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["reportName"]);
    })();
    if (!parsed_reportName.success) {
      return { success: false, reason: parsed_reportName.reason };
    }
    if (!hasProp(value, "reportType")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/reportType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reportType'.` };
    }
    const parsed_reportType = ((): ParserResult<ReportType> => {
      return ((value: unknown): ParserResult<ReportType> => {
        return ((value: unknown): ParserResult<"USERS" | "ACTIVITY" | "EXTENDED_USERS_EXPORT" | "ACTIONABLES_ACTIVITY"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/ReportType]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "USERS":
              return { success: true, value: "USERS" };
            case "ACTIVITY":
              return { success: true, value: "ACTIVITY" };
            case "EXTENDED_USERS_EXPORT":
              return { success: true, value: "EXTENDED_USERS_EXPORT" };
            case "ACTIONABLES_ACTIVITY":
              return { success: true, value: "ACTIONABLES_ACTIVITY" };
            default:
              return { success: false, reason: `[#/components/schemas/ReportType]: '${value}' expected to be enum, one of 'USERS, ACTIVITY, EXTENDED_USERS_EXPORT, ACTIONABLES_ACTIVITY'.` };
          }
        })(value);
      })(value["reportType"]);
    })();
    if (!parsed_reportType.success) {
      return { success: false, reason: parsed_reportType.reason };
    }
    if (!hasProp(value, "specialReport")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/specialReport]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'specialReport'.` };
    }
    const parsed_specialReport = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/specialReport]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["specialReport"]);
    })();
    if (!parsed_specialReport.success) {
      return { success: false, reason: parsed_specialReport.reason };
    }
    if (!hasProp(value, "targetExcel")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/targetExcel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'targetExcel'.` };
    }
    const parsed_targetExcel = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/targetExcel]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["targetExcel"]);
    })();
    if (!parsed_targetExcel.success) {
      return { success: false, reason: parsed_targetExcel.reason };
    }
    if (!hasProp(value, "toDate")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/toDate]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'toDate'.` };
    }
    const parsed_toDate = ((): ParserResult<{ year: number; month: number; day: number } | null> => {
      return ((value: unknown): ParserResult<{ year: number; month: number; day: number } | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/toDate]: '${value}' expected to be of type string.` };
        }
        const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/toDate]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
        }
        return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
      })(value["toDate"]);
    })();
    if (!parsed_toDate.success) {
      return { success: false, reason: parsed_toDate.reason };
    }
    if (!hasProp(value, "transferProtocol")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/transferProtocol]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'transferProtocol'.` };
    }
    const parsed_transferProtocol = ((): ParserResult<TransferProtocol> => {
      return ((value: unknown): ParserResult<TransferProtocol> => {
        return ((value: unknown): ParserResult<"FTP" | "SFTP" | "FTPS"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/TransferProtocol]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "FTP":
              return { success: true, value: "FTP" };
            case "SFTP":
              return { success: true, value: "SFTP" };
            case "FTPS":
              return { success: true, value: "FTPS" };
            default:
              return { success: false, reason: `[#/components/schemas/TransferProtocol]: '${value}' expected to be enum, one of 'FTP, SFTP, FTPS'.` };
          }
        })(value);
      })(value["transferProtocol"]);
    })();
    if (!parsed_transferProtocol.success) {
      return { success: false, reason: parsed_transferProtocol.reason };
    }
    if (!hasProp(value, "zipFile")) {
      return { success: false, reason: `[#/components/schemas/NewB2BReportForm/zipFile]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'zipFile'.` };
    }
    const parsed_zipFile = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/NewB2BReportForm/zipFile]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["zipFile"]);
    })();
    if (!parsed_zipFile.success) {
      return { success: false, reason: parsed_zipFile.reason };
    }
    return {
      success: true,
      value: {
        active: parsed_active.value,
        activeUsersOnly: parsed_activeUsersOnly.value,
        b2bCustomReport: parsed_b2bCustomReport.value,
        ccRecipients: parsed_ccRecipients.value,
        corporateId: parsed_corporateId.value,
        customerId: parsed_customerId.value,
        dayOfWeek: parsed_dayOfWeek.value,
        downloadType: parsed_downloadType.value,
        emailAdministrator: parsed_emailAdministrator.value,
        frequency: parsed_frequency.value,
        fromDate: parsed_fromDate.value,
        ftpFolder: parsed_ftpFolder.value,
        ftpHost: parsed_ftpHost.value,
        ftpPassphrase: parsed_ftpPassphrase.value,
        ftpPassword: parsed_ftpPassword.value,
        ftpPort: parsed_ftpPort.value,
        ftpRemoteFileName: parsed_ftpRemoteFileName.value,
        ftpUserName: parsed_ftpUserName.value,
        prefixFileName: parsed_prefixFileName.value,
        privateKey: parsed_privateKey.value,
        privateKeyContent: parsed_privateKeyContent.value,
        privateKeyEnabled: parsed_privateKeyEnabled.value,
        reportId: parsed_reportId.value,
        reportName: parsed_reportName.value,
        reportType: parsed_reportType.value,
        specialReport: parsed_specialReport.value,
        targetExcel: parsed_targetExcel.value,
        toDate: parsed_toDate.value,
        transferProtocol: parsed_transferProtocol.value,
        zipFile: parsed_zipFile.value,
      },
    };
  })(parseJsonWithNumbersAsBigint(str));
}
